
const TokenKey = 'zb-token'

export function getToken() {
  return localStorage.TokenKey
}

export function setToken(token) {
  console.log(token,123123123123)
  return localStorage.TokenKey = token
}

export function removeToken() {
  return localStorage.TokenKey =''
}
